import { server } from '@/services/'

const state = {
  isFetching: false,
  items: []
}

const getters = {}

const mutations = {
  setIsFetching (state, payload) {
    state.isFetching = payload
  },
  setItems (state, payload) {
    state.items = payload
  }
}

const actions = {

  getAll ({ commit }) {
    commit('setIsFetching', true)
    return new Promise((resolve, reject) => {
      server.get('/getUS').then(
        resp => {
          commit('setIsFetching', false)
          commit('setItems', resp.data.msgContent.data)
          resolve(true)
        },
        err => {
          reject(err.response)
        }
      )
    })

  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
